module.exports = __webpack_public_path__ + "img/se5.9ec136d6.jpg";